import { type InferOutput, minLength, object, pipe, string } from 'valibot'

export const tourImportFormValueSchema = object({
  fileKey: pipe(string(), minLength(1)),
  fileName: pipe(string(), minLength(1))
})

/**
 * 運行実績インポートのフォーム値
 */
export type TourImportFormValue = InferOutput<typeof tourImportFormValueSchema>
